// Mock data for The Founder Initiative

export const featuredBuyers = [
  {
    id: '1',
    name: 'Mark Hillick',
    title: 'CISO',
    company: 'Brex',
    category: 'Cybersecurity',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/cmjudwcq_1618876350791.jpeg'
  },
  {
    id: '2',
    name: 'Jakub Oleksy',
    title: 'SVP of Engineering',
    company: 'GitHub',
    category: 'Developer Tools',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/f76vfmby_Jakub.jpeg'
  },
  {
    id: '3',
    name: 'Leslie Hui',
    title: 'VP, Accounting Ops',
    company: 'Okta',
    category: 'Finance',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/dswa405n_1743828925447.jpeg'
  },
  {
    id: '4',
    name: 'Jon Fernandez',
    title: 'Director of Engineering',
    company: 'NVIDIA',
    category: 'Developer Tools',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/5l4lb8jz_1700534776648.jpeg'
  },
  {
    id: '5',
    name: 'Niteka Negi',
    title: 'VP, Commercial Finance',
    company: 'The Duckhorn Portfolio',
    category: 'Finance',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/26h19o7p_1718936622992.jpeg'
  },
  {
    id: '6',
    name: 'Rohan Singla',
    title: 'CISO',
    company: 'ChargePoint',
    category: 'Cybersecurity',
    image: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/prmdf5ga_1628468978125.jpeg'
  }
];

export const vcPartners = [
  {
    id: '1',
    name: 'Lightspeed Venture Partners',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/qcs6qxrm_3402.png'
  },
  {
    id: '2',
    name: 'CRV',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/hfwq03i9_CRV_Logo.svg.png'
  },
  {
    id: '3',
    name: 'Foundation Capital',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/szxst9o8_Foundation_Capital_Logo.svg.png'
  },
  {
    id: '4',
    name: 'Menlo Ventures',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/w61vgv2b_Menlo_Ventures_Logo.svg.png'
  },
  {
    id: '5',
    name: 'Redpoint',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/bj8k8grw_Redpoint_logo.png'
  },
  {
    id: '6',
    name: 'Cowboy Ventures',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/yzz62s80_63bbd087b73c8b4f6b22131e_cowboyVenturesLogo-p-500.webp'
  },
  {
    id: '7',
    name: 'Forum Ventures',
    type: 'Referral Partner',
    logo_url: 'https://customer-assets.emergentagent.com/job_pitch-buyers/artifacts/4cwccauw_Forum_Lockup_Dark_Purple.png'
  }
];

export const sponsors = [
  {
    id: '1',
    name: 'Auth0'
  },
  {
    id: '2',
    name: 'Okta Ventures'
  }
];

export const testimonials = [
  {
    id: '1',
    founder: 'Sarah Mitchell',
    company: 'DataCore',
    title: 'Founder & CEO',
    quote: "This was the most valuable hour I've spent on customer discovery. Direct feedback from CISOs who actually buy.",
    category: 'Cybersecurity',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Backed by Kleiner Perkins'
  },
  {
    id: '2',
    founder: 'Rachel Chen',
    company: 'CloudFlow',
    title: 'CEO',
    quote: "Finally got real feedback from actual buyers. This changed how we position our product.",
    category: 'Infrastructure',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Backed by Sequoia, Greylock'
  },
  {
    id: '3',
    founder: 'Marcus Johnson',
    company: 'DevTools Inc',
    title: 'Founder',
    quote: "The quality of buyers is unmatched. We closed our first enterprise deal from this event.",
    category: 'Developer Tools',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Raised $5M Series A'
  },
  {
    id: '4',
    founder: 'Priya Sharma',
    company: 'SecureData',
    title: 'Co-Founder',
    quote: "One event generated more qualified leads than 6 months of cold outreach. Game changer.",
    category: 'Cybersecurity',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Backed by a16z, Lightspeed'
  },
  {
    id: '5',
    founder: 'Alex Rivera',
    company: 'FinOps AI',
    title: 'Founder',
    quote: "Best way to validate your product with real enterprise buyers. The feedback was incredibly specific and actionable.",
    category: 'Fintech',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Raised $3.5M Seed'
  },
  {
    id: '6',
    founder: 'Jordan Lee',
    company: 'APIFlow',
    title: 'Co-Founder & CTO',
    quote: "We pivoted our entire GTM strategy based on insights from one event. Worth every minute.",
    category: 'Developer Tools',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Backed by CRV, Foundation'
  },
  {
    id: '7',
    founder: 'Emily Watson',
    company: 'SecureNet',
    title: 'CEO',
    quote: "The panelists gave us feedback that would have taken months to discover on our own. Incredibly valuable.",
    category: 'Cybersecurity',
    linkedin_url: 'https://linkedin.com/feed',
    funding_info: 'Backed by Menlo Ventures'
  }
];

export const startups = [
  {
    id: '1',
    name: 'SecureFlow',
    solution: 'AI-powered threat detection for modern cloud infrastructure',
    category: 'Cybersecurity',
    founder: 'Sarah Johnson',
    stage: 'Seed',
    referredBy: 'Lightspeed'
  },
  {
    id: '2',
    name: 'DevMetrics',
    solution: 'Real-time engineering productivity analytics for high-performing teams',
    category: 'Developer Tools',
    founder: 'Mike Chen',
    stage: 'Series A',
    referredBy: 'CRV'
  },
  {
    id: '3',
    name: 'CloudOps Pro',
    solution: 'Automated infrastructure management that reduces DevOps costs by 60%',
    category: 'Infrastructure',
    founder: 'Alex Rodriguez',
    stage: 'Seed',
    referredBy: 'Direct Application'
  },
  {
    id: '4',
    name: 'DataGuard',
    solution: 'Enterprise data privacy compliance automation for SaaS companies',
    category: 'Cybersecurity',
    founder: 'Emily Park',
    stage: 'Pre-seed',
    referredBy: 'Foundation Capital'
  },
  {
    id: '5',
    name: 'APIFlow',
    solution: 'Next-gen API gateway with built-in observability and security',
    category: 'Developer Tools',
    founder: 'Jordan Lee',
    stage: 'Series A',
    referredBy: 'Menlo Ventures'
  },
  {
    id: '6',
    name: 'FinOps AI',
    solution: 'Machine learning platform for cloud cost optimization and forecasting',
    category: 'Infrastructure',
    founder: 'Taylor Swift',
    stage: 'Seed',
    referredBy: 'Direct Application'
  }
];

export const rotatingBuyerTitles = [
  'CISO at Brex',
  'SVP of Engineering at GitHub',
  'VP of Accounting Ops at Auth0',
  'CISO at ChargePoint',
  'SVP of Engineering & Product at Nokia',
  'Director of Engineering at NVIDIA'
];
